import { isAfter, isSameDay, isWithinInterval } from 'date-fns';
import type { SettingsSpecialInterval } from '../settings-special-interval/settings-special-interval';
import { getWorkHoursIntervalsForDate } from '../work-hours-interval/get-work-hours-intervals-for-date';
import type { SpecialInterval } from './special-interval';

export function getSpecialIntervalsFromDate(
  settingsSpecialIntervals: SettingsSpecialInterval[],
  givenDate: Date = new Date()
) {
  return settingsSpecialIntervals
    .filter(
      ({ dates: [, endDate] }) =>
        isSameDay(endDate, givenDate) || isAfter(endDate, givenDate)
    )
    .flatMap((day) => formatSpecialInterval(day, givenDate));
}

const formatSpecialInterval = (
  day: SettingsSpecialInterval,
  givenDate = new Date()
): SpecialInterval => ({
  id: day.id,
  description: day.description,
  dates: day.dates,
  hours: getWorkHoursIntervalsForDate(day.settingsHours, day.dates[0], false),
  isClosed: day.isClosed,
  isToday:
    isSameDay(givenDate, day.dates[0]) ||
    isWithinInterval(givenDate, { start: day.dates[0], end: day.dates[1] }) ||
    isSameDay(givenDate, day.dates[1])
});
